import { CheckCircle2Icon } from "lucide-react";
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import type {
	InteractionAnswer,
	ParsedInteraction,
} from "../../../../email-assistant/core/toolInteractions";

interface Props {
	interaction: Pick<ParsedInteraction, "questions">;
	answers: InteractionAnswer[];
}

// Resolved "you answered" record in chat history.
export function ResolvedInteractionCard({ interaction, answers }: Props) {
	const byId = new Map(answers.map((a) => [a.questionId, a]));
	const rows = interaction.questions
		.map((q) => ({ q, a: byId.get(q.id) }))
		.filter(
			(
				r,
			): r is {
				q: (typeof interaction.questions)[number];
				a: InteractionAnswer;
			} => Boolean(r.a),
		);
	if (rows.length === 0) return null;

	return (
		<div className="my-2 max-w-full rounded-xl border border-primary/20 bg-primary/[0.04] px-3.5 py-2.5">
			<div className="flex items-center gap-2 text-xs font-semibold text-primary">
				<CheckCircle2Icon className="size-4" />
				You answered · {rows.length} {rows.length === 1 ? "detail" : "details"}
			</div>
			<TooltipProvider delay={300}>
				<dl className="mt-2 flex flex-col gap-1.5">
					{rows.map(({ q, a }) => {
						const value = Array.isArray(a.value) ? a.value.join(", ") : a.value;
						return (
							<div key={q.id} className="flex gap-3 text-sm">
								<dt className="w-32 shrink-0">
									<Tooltip>
										<TooltipTrigger
											render={<span />}
											className="block w-full cursor-pointer truncate text-left text-muted-foreground"
										>
											{q.question}
										</TooltipTrigger>
										<TooltipContent>{q.question}</TooltipContent>
									</Tooltip>
								</dt>
								<dd className="min-w-0 flex-1 font-medium text-foreground">
									{value}
									{a.typed ? (
										<span className="ml-1.5 rounded border bg-muted px-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
											typed
										</span>
									) : null}
								</dd>
							</div>
						);
					})}
				</dl>
			</TooltipProvider>
		</div>
	);
}
